<template>
  <div>
    <!--    <sweet-modal-->
    <!--      class="editOrderSweet"-->
    <!--      ref="blackListModal"-->
    <!--      @close="onCancel"-->
    <!--      overlay-theme="dark"-->
    <!--    >-->
    <template v-if="!localRecord">
      <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
    </template>
    <div class="text-left" v-if="localRecord">
      <h3>{{
          localRecord && localRecord.id ? 'Обновить запись в черном списке' : 'Добавить запись в черный список'
        }}</h3>
      <form v-if="localRecord" action="" @submit="addToList">
        <div class="form-group">
          <label for="">Номер телефона</label>
          <input :disabled="!!localRecord.id" v-model="localRecord.phone_num" placeholder="+7 915 000 00 00"
                 class="form-control" type="text" required>
        </div>
        <div class="pb-2 card mb-1" v-if="localRecord.comments">
          <div class="card-header"><h6>Записи</h6></div>
          <div class="card-body">
            <div class="comment" v-for="(comment, index) in localRecord.comments" :key="`comment_${index}`">
              <p>{{ comment.text }}</p>
              <template v-if="comment.drugs && comment.drugs.length">
                <hr>
                <p v-for="drug in comment.drugs">{{ drug && drug.title }}</p>
              </template>
              <p class="author">{{ comment.user_name }}: {{ comment.created_at }}</p>
            </div>
          </div>
        </div>
        <div class="p-2" v-if="localRecord.id">
          <div class="form-group">
            <input type="checkbox" id="ch_1" v-model="localRecord.is_active">
            <label class="pl-2 pointer" for="ch_1">Запись активна, информация отображается в заявках</label>
          </div>
        </div>
        <div class="form-group">
          <label for="">Комментарий</label>
          <textarea v-model="localRecord.comment" class="form-control" :required="!localRecord.id"
                    placeholder="Комментарий" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label for="">Добавить препараты</label>
          <div v-if="drugsSelected && drugsSelected.length">
            <template v-for="drug, index in drugsSelected">
              <div class="flex justify-content-between mb-1" v-if="drug">
                {{ drug.title }}
                <button type="button" @click="removeDrug(index)" class="btn btn-sm btn-warning">Х</button>
              </div>
            </template>
          </div>
          <DrugSearchNew
            ref="drugSelect"
            :onDrugSelect="onDrugSelect"/>
        </div>
        <!--          <div class="text-right">-->
        <!--            <vue-ladda type="submit" button-class="btn btn-primary"-->
        <!--                       data-style="zoom-in"-->
        <!--                       :loading="saveLoading">Сохранить-->
        <!--            </vue-ladda>-->
        <!--            <button @click="onCancel" type="button" class="ladda-button btn btn-default">Отмена</button>-->
        <!--          </div>-->
      </form>
    </div>
    <!--    </sweet-modal>-->
  </div>

</template>

<script>

import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import DrugSelect from '../drugs/drugSearch'
import {SweetModal} from 'sweet-modal-vue'
import moment from 'moment'
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import EmptyCardModal from "@/components/modals/EmptyCardModal.vue";

export default {
  props: ['newRecord', 'onCancel', 'updateRecordList', 'blackListPhoneNum'],
  components: {
    SweetModal,
    VueLadda,
    DrugSearchNew,
    EmptyCardModal,
  },
  data() {
    return {
      loadingColor: this.$constants.LOADING_COLOR,
      localRecord: null,
      saveLoading: false,
      drugsSelected: [],
    }
  },
  async mounted() {
    // this.$refs.blackListModal.open()
    if (this.blackListPhoneNum) {
      await this.getBlackListData()
    } else {
      this.localRecord = {...this.newRecord}
    }
  },
  methods: {
    async getBlackListData() {
      const {data} = await api.index('/blacklist/clientPhoneNum?num=' + this.blackListPhoneNum)
      if (data.success) {
        if (data.record) {
          this.localRecord = data.record
        } else {
          this.localRecord = {}
        }
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
        this.onCancel()
      }
    },
    removeDrug(index) {
      delete this.drugsSelected[index]
      this.drugsSelected = [...this.drugsSelected]
    },
    onDrugSelect(e) {
      this.drugsSelected.push({id: e.id, title: e.title})
      this.$refs.drugSelect.drug = null
    },
    async addToList(e = null) {
      if (e) e.preventDefault();
      this.saveLoading = true
      const record = {
        id: this.localRecord.id,
        phone_num: this.localRecord.phone_num,
        comment: this.localRecord.comment,
        drugs: this.drugsSelected,
        is_active: this.localRecord.id ? this.localRecord.is_active : 1
      }
      const result = await this.updateRecord(record)
      if (result.success) {
        this.Toast.fire({
          type: 'success',
          title: 'Сохранено'
        })
        this.onCancel({
          text: this.localRecord.comment,
          user_name: 'Вы',
          created_at: moment().format('YYYY-MM-DD HH:mm:00')
        });
      } else {
        this.Toast.fire({
          type: 'warning',
          title: result.message || 'Ошибка сервера'
        })
      }
      this.saveLoading = false
    },
    async updateRecord(record) {
      const {data} = await api.post('/blacklist/clientPhoneNum', {
        ...record,
        type: 'update',
      })
      return data
    },
  }
}

</script>

<style scoped>
.comment {
  border-bottom: 1px solid lightgray;
  background-color: #f4f4f4;
  padding: 2px;
  margin-bottom: 10px;
}

hr {
  margin: 3px 0;
}

.comment p {
  margin-bottom: 0;
}

.comment .author {
  text-align: right;
  font-size: 12px;
}
</style>
